import { BlogListPage } from '@denqfabrik/ghost-blog/pages';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/i18n';
import type { SupportedLang } from '@/i18n/LanguageProvider';

const BLOG_META: Record<SupportedLang, { title: string; description: string }> = {
  de: {
    title: 'Blog — Aletiq',
    description:
      'Einblicke in KI-Agent-Verifizierung, Testautomatisierung und wie Entwicklerteams auf strukturierte KI-Qualitätssicherung umstellen.',
  },
  en: {
    title: 'Blog — Aletiq',
    description:
      'Insights on AI agent verification, test automation, and how development teams adopt structured AI quality assurance.',
  },
  it: {
    title: 'Blog — Aletiq',
    description:
      'Approfondimenti sulla verifica di agenti IA, automazione dei test e su come i team di sviluppo adottano un controllo qualità IA strutturato.',
  },
  es: {
    title: 'Blog — Aletiq',
    description:
      'Perspectivas sobre verificación de agentes IA, automatización de pruebas y cómo los equipos de desarrollo adoptan control de calidad IA estructurado.',
  },
  fr: {
    title: 'Blog — Aletiq',
    description:
      'Perspectives sur la vérification d’agents IA, l’automatisation des tests et la manière dont les équipes de développement adoptent une assurance qualité IA structurée.',
  },
};

interface AletiqBlogListPageProps {
  config: Parameters<typeof BlogListPage>[0]['config'];
}

export default function AletiqBlogListPage({ config }: AletiqBlogListPageProps) {
  const { lang } = useTranslation();
  const meta = BLOG_META[lang];
  useDocumentTitle({ title: meta.title, description: meta.description });
  return <BlogListPage config={config} />;
}
